import { HoneymoonDestination, HoneymoonSubDestination } from '../types';
import {
  Dek,
  DestinationImage,
  DestinationLink,
  DestinationName,
  DestinationsWrapper,
  HeaderWrapper,
  StyledBreadcrumbs,
  StyledH1,
} from './DestinationHeader.styles';

export type DestinationHeaderProps = {
  destinations: (HoneymoonSubDestination | HoneymoonDestination)[];
  title: string;
  description: string;
  showBreadcrumbs?: boolean;
  showBottomBorder?: boolean;
};

export const DestinationHeader = (props: DestinationHeaderProps) => {
  const { destinations, title, showBreadcrumbs, description, showBottomBorder } = props;

  return (
    <div>
      {showBreadcrumbs && (
        <StyledBreadcrumbs
          currentSelectionLabel={title}
          linkItems={[
            {
              label: 'Honeymoons',
              to: '/wedding-planning/honeymoons',
            },
          ]}
        />
      )}
      <HeaderWrapper noBreadcrumbs={!showBreadcrumbs} showBottomBorder={showBottomBorder}>
        <StyledH1 presentation="h3">{title}</StyledH1>
        <Dek>{description}</Dek>
        <DestinationsWrapper>
          {destinations.map(d => {
            return (
              <DestinationLink
                href={`/wedding-planning/honeymoons/destination/${d.slug}`}
                key={`/wedding-planing/honeymoon-destination-${d.slug}`}
              >
                <DestinationImage src={d.categoryNodeImage} />
                <DestinationName>{d.displayTitle}</DestinationName>
              </DestinationLink>
            );
          })}
        </DestinationsWrapper>
      </HeaderWrapper>
    </div>
  );
};
